export default __webpack_public_path__ + "static/media/tropical-land.b76294f8.webp";